import { useMutation, MutationOptions } from 'react-query';
import useAbortController from '../../hooks/useAbortController';
import ResidentService from '../../services/residentService';

const useCompleteUnitTransferSetupMutation = ({
  organizationId,
  propertyId,
  householdId,
  applicationId,
  options,
}: {
  organizationId: string,
  propertyId: string,
  householdId: string,
  applicationId: string,
  options?: MutationOptions,
}) => {
  const abortControllerOptions = useAbortController();

  return useMutation(
    async (unitId: string) =>
      new ResidentService().completeUnitTransferSetup(
        organizationId,
        propertyId,
        householdId,
        { applicationId, unitId },
        abortControllerOptions,
      ),
    {
      ...options,
      enabled: Boolean(
        organizationId && propertyId && householdId && applicationId,
      ),
    },
  );
};

export default useCompleteUnitTransferSetupMutation;
